export default "__VITE_PUBLIC_ASSET__72f9fefb__"